import { env } from "@beztack/env/ui";
import { urlBase64ToUint8Array } from "@/lib/pwa/vapid-key";

export async function registerRiderServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return null;
  }
  try {
    const registration = await navigator.serviceWorker.register("/rider-sw.js", {
      scope: "/rider/",
    });
    return registration;
  } catch (error) {
    console.error("Failed to register rider service worker", error);
    return null;
  }
}

export async function ensureRiderPushSubscription(): Promise<PushSubscription | null> {
  const registration = await registerRiderServiceWorker();
  if (!registration) {
    return null;
  }
  if (!env.VITE_VAPID_PUBLIC_KEY) {
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    return null;
  }

  const existing = await registration.pushManager.getSubscription();
  if (existing) {
    return existing;
  }

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(env.VITE_VAPID_PUBLIC_KEY),
  });

  const apiBase = env.VITE_API_URL.replace(/\/$/, "");
  await fetch(`${apiBase}/api/push/subscribe`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(subscription.toJSON()),
  });

  return subscription;
}
